import React from "react";
import { StyledDivider, StyledIcon } from "./Divider.styled";
import { useIsMobileSize } from "../../../hooks/use-is-mobile-size";

export type Direction = "left" | "right" | "center";

export interface DividerProps {
  className?: string;
  direction?: Direction;
}

const Divider: React.FC<DividerProps> = ({
  direction = "center",
  className = "",
}) => {
  const isMobileSize = useIsMobileSize();

  return (
    <StyledDivider className={`${className} divider`}>
      <StyledIcon
        name={
          (isMobileSize && direction !== "center") || direction === "left"
            ? "PointerSmallLeft"
            : "PointerLeft"
        }
        $isSmall={
          (isMobileSize && direction !== "center") || direction === "left"
        }
      />
      <StyledIcon
        name={
          (isMobileSize && direction !== "center") || direction === "right"
            ? "PointerSmallRight"
            : "PointerRight"
        }
        $isSmall={
          (isMobileSize && direction !== "center") || direction === "right"
        }
      />
    </StyledDivider>
  );
};

export default Divider;
